<div class="page-content bg-light">
    <div class="dz-bnr-inr bg-secondary dz-bnr-inr-md"
        style="background-image:url(https://ezhuthupizhai.in/wp-content/uploads/2024/03/Banner_3-scaled-1.jpg);">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="dz-bnr-inr-entry text-start">
                        <h1 class="text-white">Refund and Returns Policy</h1>
                        <nav aria-label="breadcrumb" class="breadcrumb-row">
                            <ul class="breadcrumb text-white">
                                <li class="breadcrumb-item"><a href="/home" class="text-white">Home</a></li>
                                <li class="breadcrumb-item text-white">Refund and Returns Policy</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <section class="content-inner">
        <div class="container">
            <div class="row about-style2 align-items-xl-center align-items-start">
                <h2 class="fs-4 mb-2">Overview</h2>
                <p>We want you to be happy with your purchase from Ezhuthupizhai. If you need to return an item, please
                    read our policy below.</p>
                <p>You have <strong>30 days</strong> from the date of purchase to return an item for a full refund or
                    exchange. After 30 days, we can no longer offer a refund or exchange.</p>
                <p>To be eligible for a return, your item must be:</p>
                <ul class="mb-3 ms-3">
                    <li>Unused and in the same condition you received it.</li>
                    <li>In its original packaging.</li>
                </ul>

                <h3 class="fs-4 mb-2">Items That Cannot Be Returned</h3>
                <p>Certain goods are exempt from being returned. These include:</p>
                <ul class="mb-1 ms-3">
                    <li>Perishable goods (e.g., food, flowers, newspapers, magazines)</li>
                    <li>Intimate or sanitary goods</li>
                    <li>Hazardous materials</li>
                    <li>Flammable liquids or gases</li>
                    <li>Gift cards</li>
                    <li>Downloadable software products</li>
                    <li>Some health and personal care items</li>
                </ul>
                <p>We require a <strong>receipt or proof of purchase</strong> to complete your return. Please <strong>do
                        not send your purchase back to the manufacturer.</strong></p>

                <h3 class="fs-4 mb-2">Partial Refunds May Be Granted For:</h3>
                <ul class="mb-1 ms-3">
                    <li>Books with obvious signs of use.</li>
                    <li>Opened CDs, DVDs, VHS tapes, software, video games, cassette tapes, or vinyl records.</li>
                    <li>Any item not in its original condition, damaged, or missing parts due to reasons not caused by
                        our error.</li>
                    <li>Any item that is returned more than 30 days after delivery.</li>
                </ul>

                <h2 class="fs-4 mb-2">Refunds Process</h2>
                <p>Once we receive and inspect your returned item, we'll send you an email to confirm its arrival and to
                    notify you whether your refund has been approved or rejected.</p>
                <p>If approved, your refund will be processed, and a credit will automatically be applied to your
                    original method of payment within a certain number of days.</p>

                <h3 class="fs-4 mb-2">What if my refund is late or missing?</h3>
                <ul class="mb-1 ms-3">
                    <li><strong>Check your bank account again.</strong></li>
                    <li><strong>Contact your credit card company.</strong> It might take some time for the refund to be
                        officially posted.</li>
                    <li><strong>Contact your bank.</strong> There's often a processing period before a refund appears.
                    </li>
                </ul>
                <p>If you've done all of this and still haven't received your refund, please contact us at <a
                        href="mailto:{{email}}">{{email}}</a>.</p>

                <h3 class="fs-4 mb-2">Sale Items</h3>
                <p>Only <strong>regular-priced items</strong> can be refunded. <strong>Sale items are not eligible for
                        refunds.</strong></p>

                <h2 class="fs-4 mb-2">Exchanges</h2>
                <p>We only replace items if they are <strong>defective or damaged</strong>. If you need to exchange an
                    item for the same one, please email us at <a href="mailto:{{email}}">{{email}}</a> and send your
                    item to:</p>
                <address>
                    <strong>Ezhuthupizhai Returns</strong><br>
                    78/42, 3rd Main Rd,<br>
                    Gandhi Nagar, 2nd floor, Saradha Apartments,<br>
                    Adyar, Chennai, Tamil Nadu 600020.
                </address>

                <h2 class="fs-4 mb-2">Gifts</h2>
                <p>If the item was marked as a gift when purchased and shipped directly to you, you’ll receive a **gift
                    credit** for the value of your return. Once we receive the returned item, a gift certificate will be
                    mailed to you.</p>
                <p>If the item wasn’t marked as a gift when purchased, or if the gift giver had the order shipped to
                    themselves to give to you later, we will send the refund to the gift giver.</p>

                <h2 class="fs-4 mb-2">Shipping Returns</h2>
                <p>To return your product, please mail it to:</p>
                <address>
                    <strong>Ezhuthupizhai Returns</strong><br>
                    78/42, 3rd Main Rd,<br>
                    Gandhi Nagar, 2nd floor, Saradha Apartments,<br>
                    Adyar, Chennai, Tamil Nadu 600020.
                </address>
                <p><strong>You are responsible for paying your own shipping costs for returning your item.</strong>
                    Shipping costs are non-refundable. If you receive a refund, the cost of return shipping will be
                    deducted from your refund.</p>
                <p>The time it takes for your exchanged product to reach you may vary depending on your location.</p>
                <p>For more expensive items, consider using a <strong>trackable shipping service</strong> or purchasing
                    <strong>shipping insurance</strong>, as we cannot guarantee that we will receive your returned item.
                </p>

                <h2 class="fs-4 mb-2">Need Help?</h2>
                <p>For any questions regarding refunds and returns, please contact us at <a
                        href="mailto:{{email}}">{{email}}</a>.</p>
            </div>
        </div>
    </section>
</div>